import {useEffect, useMemo, useState} from 'react';
import {
  getAnswerCount,
  getFirstNonSkipQuestionNumber,
  getFirstUnansweredQuestionNumber,
  getPreviousNonSkipQuestionNumber, getQuestionCountAfterConditions
} from "../logic/assessment";
import {
  ASSESSMENT_ANSWERS,
  ASSESSMENT_QUESTIONS, GET_ASSESSMENT_OPTIONS_BY_UUID,
  SAVE_ASSESSMENT_ANSWERS,
  UPDATE_MENTORS_ON_PROGRAM
} from "../../apollo/queries";
import {client} from "../../apollo/client";
import {UpdateMentorsOnProgram} from "../../apollo/types/updateMentorsOnProgram";


const fetchAssessment = async (assessmentId) => {
  const answers = await client.query({
    query: ASSESSMENT_ANSWERS,
    variables: {
      uuid: assessmentId
    },
  });

  const questions = await client.query({
    query: ASSESSMENT_QUESTIONS,
    variables: {
      uuid: assessmentId
    }
  });

  const options = await client.query({
    query: GET_ASSESSMENT_OPTIONS_BY_UUID,
    variables: {
      uuid: assessmentId
    }
  });
  // console.log({
  //   answers: answers.data.assessmentAnswers.answers,
  //   questions: questions.data.assessmentQuestions,
  //   options: options.data.assessmentOptionsByAssessmentUuid
  // })

  let parsedQuestions = [];
  for(const question of questions.data.assessmentQuestions) {
    const parsedQuestion = Object.assign({}, question)
    if(question.minValue === null) delete parsedQuestion.minValue
    if(question.maxValue === null) delete parsedQuestion.maxValue
    if(question.condition === null) delete parsedQuestion.condition
    if(question.options === null) delete parsedQuestion.options
    if(question.totalValue === null) delete parsedQuestion.totalValue
    if(question.unitPostfix === null) delete parsedQuestion.unitPostfix
    if(question.unitPrefix === null) delete parsedQuestion.unitPrefix
    if(question.validator === null) delete parsedQuestion.validator
    if(question.prefill === null) delete parsedQuestion.prefill
    if(question.options !== null) {
        const options = []
        for(const option of question.options) {
          const parsedOption = Object.assign({}, option);
          if(option.maxValue === null) delete parsedOption.maxValue
          if(option.minValue === null) delete parsedOption.minValue
          if(option.maxLength === null) delete parsedOption.maxLength
          options.push(parsedOption)
        }
        parsedQuestion.options = options;
    }
    parsedQuestions.push(parsedQuestion)
  }

  return {
    info: {
      // @ts-ignore
      questions: parsedQuestions,
      options: options.data.assessmentOptionsByAssessmentUuid
    },
    data: {
      answers: {
        ...{
          update_scan_question_number: false
        },
        ...answers.data.assessmentAnswers.answers
      }
    },
  };
};

const saveAnswers = async (assessmentUuid, answers, version = 0) => {
    await client.mutate({
      mutation: SAVE_ASSESSMENT_ANSWERS,
      variables: {
        input: {
          assessmentUuid,
          answers,
          version,
          finishAssessment: false
        }
      }
    });
}

export default (assessmentId, requestedQuestionNumber) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [result, setResult] = useState();
  console.log({assessmentId, requestedQuestionNumber})
  const currentQuestionNumber = {number: requestedQuestionNumber};
  const [firstUnansweredQuestionNumberRes, setFirstUnansweredQuestionNumber] = useState(null)

  useEffect(() => {
    (async () => {
      try {
        const res = await fetchAssessment(assessmentId);
        setResult(res)
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    })();
  }, [assessmentId]);

  useEffect(() => {
    (async () => {
        console.log('useEffect currentQuestionNumber')
        if(!result) {
          currentQuestionNumber.number = requestedQuestionNumber
          return
        }

        const { info, data } = result;
        // Make sure our number is set and within range
        const firstUnansweredQuestionNumber = await getFirstUnansweredQuestionNumber(info.questions, data.answers);
        let currQuestionNumber = requestedQuestionNumber
        setFirstUnansweredQuestionNumber(firstUnansweredQuestionNumber)
        if (currQuestionNumber === undefined) {
          currQuestionNumber = firstUnansweredQuestionNumber;
        } else if (
            Number.isNaN(currQuestionNumber) ||
            !Number.isInteger(currQuestionNumber) ||
            currQuestionNumber < 1 ||
            currQuestionNumber > firstUnansweredQuestionNumber
        ) {
          currQuestionNumber = firstUnansweredQuestionNumber;
        }

        // Make sure this is not a question to skip
        const firstNonSkipQuestionNumber = await getFirstNonSkipQuestionNumber(
            info.questions,
            data.answers,
            currQuestionNumber
        );
        if (firstNonSkipQuestionNumber > currQuestionNumber) {
          currQuestionNumber = firstNonSkipQuestionNumber;
        }
      currentQuestionNumber.number = Math.min(currQuestionNumber, info.questions.length);
    })();
  }, [requestedQuestionNumber]);

  let assessment;

  if (result) {
    console.log({resultCurrNumber: currentQuestionNumber.number})
    const { info, data } = result;
    assessment = { info, data };

    assessment = {
      currentQuestionNumber: currentQuestionNumber.number,
      firstUnansweredQuestionNumber: firstUnansweredQuestionNumberRes,
      info,
      data,
      saveAnswers: async answers => {
        const { key } = info.questions[currentQuestionNumber.number === 0 ? 0 : currentQuestionNumber.number - 1];
        for (const [question, answer] of Object.entries(answers)) {
          console.log(`setting answer for ${question} to ${answer}`)
          data.answers[question] = answer;
        }
        if (data.answers.update_scan_question_number !== undefined && data.answers.update_scan_question_number !== false) {
          data.answers.update_scan_question_number = currentQuestionNumber.number;
        }
        console.log('answers', assessment.data.answers);
        setResult(result);
        await saveAnswers(assessmentId, assessment.data.answers)
      },
    };
  }



  return {
    assessment,
    loading,
    error,
  };
};
